import NoResultsFound from '../Templates/NoResultsFound';

export default class NoResultsFoundError extends Error {
    constructor(message) {
      super(message || "No results found"); // (1)
      this.name = "NoResultsFoundError"; // (2)
      this.template = NoResultsFound;
    }
  }


// WEBPACK FOOTER //
// ./src/components/Helpers/Errors/CustomErrors/NoResultsFoundError.js